var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtPmobileImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 182.589,
    height: 214.145,
    viewBox: "0 0 182.589 214.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#326ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e85467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b01c30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7e1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4e6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#469dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234f80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.136,
    y1: 0.167,
    x2: 1.07,
    y2: 1.021,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#ffbe69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8f5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.061,
    y1: 0.367,
    x2: 1.094,
    y2: 1.04,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c42d40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 0.5,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8774",
    "data-name": "Group 8774",
    transform: "translate(-105.206 -109.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8773",
    "data-name": "Group 8773",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8771",
    "data-name": "Group 8771",
    transform: "translate(127 160.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4632",
    "data-name": "Group 4632",
    transform: "translate(43.377 103.71)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 26.549,
    cy: 6.273,
    rx: 26.549,
    ry: 6.273,
    transform: "translate(0 47.316)",
    fill: "#dde1f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4631",
    "data-name": "Group 4631",
    transform: "translate(6.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M719.289,795.11s-8.476,1.254-8.331,1.17,15.513,7.8,15.513,7.8l15.143-6.785L734.1,795.11Z",
    transform: "translate(-705.877 -755.901)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M715.014,809.546l-.127,0h-.078c-2.157.025-3.564-.029-3.564-.029s-.1.023-.292.062c-1.844.382-11.784,2.276-10.937-1.469.743-3.289,6.706-2.88,9.1-2.578a.108.108,0,0,1,.024,0c.6.076.965.144.965.144s1.187-.51,3.06-1.237l.235-.093c6.17-2.394,19.145-6.933,22.5-4.206v0c.037.028.073.06.108.092,0,0,.005,0,.006.005.036.034.069.069.1.1a.768.768,0,0,1,.084.1.275.275,0,0,1,.031.036,2.146,2.146,0,0,1,.207.314,1.705,1.705,0,0,1,.078.167,2.074,2.074,0,0,1,.127.393c.03.141.055.278.072.414a4.041,4.041,0,0,1,.032.709C736.479,808.525,722.044,809.453,715.014,809.546Z",
    transform: "translate(-698.347 -758.771)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M743.328,809.962l-.239-.7-.1-.307a0,0,0,0,1,0,0l-1.622-4.794-.233-.687c6.175-2.4,19.553-6.461,22.969-3.616v0a1.14,1.14,0,0,1,.108.1s.005,0,.006.005c.036.034.069.069.1.1a.764.764,0,0,1,.084.1.281.281,0,0,1,.031.036,2.165,2.165,0,0,1,.207.314,1.706,1.706,0,0,1,.078.167,2.084,2.084,0,0,1,.127.393c.03.141.055.278.072.414a4.047,4.047,0,0,1,.032.709C764.7,808.311,750.361,809.869,743.328,809.962Z",
    transform: "translate(-726.549 -758.482)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M706.582,818.509s-11.245-2.2-11.735,2.557c-.526,5.107,12.878,1.283,12.878,1.283s-5.17,1.131-4.924-1.768C703.038,817.775,706.582,818.509,706.582,818.509Z",
    transform: "translate(-694.831 -771.584)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M746.333,722.124c-2.207,3.1-.233,11.583-.233,11.583H731.284c.409-.58,1.563-7.892-1.036-11.923a9.566,9.566,0,0,1,.325-11.558l6.162-1.12.393-1.962.27-1.351.063-.314h2.771l.1.589.217,1.284.321,1.895,5.664,1.229S751.386,715.024,746.333,722.124Z",
    transform: "translate(-717.873 -694.498)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M742.247,738.92a6.13,6.13,0,0,1-1.831,3.03c-2.56,2.629-7.773,2.511-11.35,3.467l-.373-1.906s6.385-1.8,7.758-4.041a2.167,2.167,0,0,0,.288-.66c.465-2.232-2.119-5.022-2.119-5.022l-.275-12.958s8.679,13.208,7.9,18.089Zm-17.9,4.623.065,1.267a.12.12,0,0,0-.014-.231c-3.187-.659-8.426.253-10.976-1.913a7.506,7.506,0,0,1-2.633-4.25c-.777-4.881,7.688-17.833,7.688-17.833l-.313,12.941s-2.584,2.791-2.119,5.023a3.611,3.611,0,0,0,.855,1.422C718.815,742.213,724.349,743.544,724.349,743.544Z",
    transform: "translate(-705.73 -704.846)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M738.5,725.015l-.005-.014c-1.63-3.344-3.558-6.128-4.9-6.627l-.012-.012-.063-.014a1.2,1.2,0,0,0-.214-.047l-5.386-1.171c-.538,1.156-3.9,1.237-4.135-.142l-6.165,1.122,0,0c-1.687.557-4.548,5.083-6.368,9.666a.222.222,0,0,0-.008.026c-1.282,3.23-2.043,6.483-1.508,8.386a9.193,9.193,0,0,0,2.84,4.285l1.074-.893,2.673-2.223c-.457-.534-1-.882-1.08-1.279-.348-1.669,1.85-3.579,2.981-4.437h0c1.349,4.071.462,9.45.113,9.944h14.816s-1.573-6.759-.339-10.414c1.146,1.081,3.37,3.429,3.021,5.1a2.075,2.075,0,0,1-.261.677l2.877,1.864,1.1.713a.29.29,0,0,0,.371-.046,6.5,6.5,0,0,0,1.609-3.027C741.993,733.886,740.465,729.051,738.5,725.015Z",
    transform: "translate(-704.918 -702.382)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M739,807.022c.892,3.808-9.246,1.962-11.127,1.588l-.3-.06s-1.469.069-3.71.06h-.131a76.714,76.714,0,0,1-12.378-.964c-5.29-.942-9.83-2.77-9.822-6.274a.074.074,0,0,0,0-.019,4.034,4.034,0,0,1,.027-.436.017.017,0,0,0,0-.008c.018-.152.044-.306.076-.463a2.094,2.094,0,0,1,.126-.4,1.744,1.744,0,0,1,.079-.171c.031-.058.064-.115.1-.17a0,0,0,0,0,0,0c.033-.051.069-.1.107-.149a.282.282,0,0,1,.032-.037.806.806,0,0,1,.085-.1c.034-.036.068-.072.1-.106,0,0,0-.007.006-.005a3.564,3.564,0,0,1,1.685-.8c4.836-1.076,15.813,2.688,21.378,4.794l.24.092c1.914.724,3.126,1.234,3.126,1.234s.374-.072.981-.154l.024,0c2.433-.328,8.5-.794,9.288,2.549Z",
    transform: "translate(-699.422 -758.1)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M725.81,802.386l-.231.7-1.716,5.213-.237.718a66.158,66.158,0,0,1-11.128-1.005l0,0c-5.764-1.068-10.983-3.145-10.963-6.95a.074.074,0,0,0,0-.019c0-.143.011-.289.027-.435a.017.017,0,0,0,0-.008c.018-.152.044-.306.076-.463a2.1,2.1,0,0,1,.126-.4,1.749,1.749,0,0,1,.079-.171c.031-.058.064-.115.1-.17a0,0,0,0,0,0,0c.033-.051.069-.1.107-.149a.283.283,0,0,1,.032-.037.815.815,0,0,1,.085-.1c.034-.036.068-.072.1-.106,0,0,0-.007.006-.005a3.784,3.784,0,0,1,1.769-.869C709.017,796.914,720.256,800.285,725.81,802.386Z",
    transform: "translate(-699.422 -757.793)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M785.36,817.188s11.435-2.332,11.974,2.505c.579,5.2-13.106,1.415-13.106,1.415s5,.947,4.725-2c-.265-2.855-3.593-1.916-3.593-1.916Z",
    transform: "translate(-756.074 -770.641)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M747.395,755.044H728.762c-.655,0-1.085.666-.963,1.469l1.837,12.11a1.137,1.137,0,0,0,1.081.953h14.722a1.137,1.137,0,0,0,1.081-.953l1.837-12.11c.122-.8-.308-1.469-.962-1.469Z",
    transform: "translate(-717.402 -728.453)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M746.862,678.224a4.737,4.737,0,0,1-.419-5.54s.544.985,1.189.713c0,0,.034-2.311,4.724-2.787,0,0-.34.917-.17,1.156,1.546-.68,3.047,1.008,4.554.374,0,0,.416,2.678-1.317,4.241a2.387,2.387,0,0,1-.348,1.843C754.463,679.142,746.862,678.224,746.862,678.224Z",
    transform: "translate(-729.706 -670.611)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M749.1,686.23s-1.013-.991-1.108-.029c-.113,1.138,1.241,1.984,1.241,1.984s.33,3.518,3.3,3.518c2.944,0,3.437-3.532,3.437-3.532s1.549-.422,1.22-1.76c-.156-.635-.963.014-.963.014v-1.671a3.037,3.037,0,0,1-2.419-.264c-1.154-.5-1.565-1.182-2.55-1.143A2.639,2.639,0,0,0,749.1,686.23Z",
    transform: "translate(-731.246 -679.335)",
    fill: "#ffd8d9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4636",
    "data-name": "Group 4636",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4-2",
    "data-name": "Ellipse 4",
    cx: 69.926,
    cy: 16.523,
    rx: 69.926,
    ry: 16.523,
    transform: "translate(0 124.622)",
    fill: "#dde1f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4631-2",
    "data-name": "Group 4631",
    transform: "translate(16.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109-2",
    "data-name": "Path 109",
    d: "M732.9,795.11s-22.325,3.3-21.944,3.082,40.859,20.539,40.859,20.539L791.7,800.859l-19.775-5.75Z",
    transform: "translate(-697.581 -691.84)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110-2",
    "data-name": "Path 110",
    d: "M739.6,826.287c-.113,0-.226,0-.334,0h-.207c-5.68.065-9.388-.076-9.388-.076s-.272.062-.77.163c-4.856,1.007-31.038,6-28.807-3.87,1.956-8.663,17.664-7.587,23.964-6.791a.268.268,0,0,1,.062.008c1.572.2,2.541.378,2.541.378s3.126-1.344,8.058-3.257c.2-.08.412-.164.62-.244,16.25-6.307,50.424-18.261,59.271-11.077v.005c.1.074.193.157.284.241.006,0,.014,0,.017.013.094.089.182.181.271.273a2.006,2.006,0,0,1,.222.252.728.728,0,0,1,.083.1,5.68,5.68,0,0,1,.545.826,4.5,4.5,0,0,1,.206.44,5.461,5.461,0,0,1,.333,1.036c.08.37.146.732.19,1.09a10.68,10.68,0,0,1,.085,1.867c-.711,15.931-38.73,18.376-57.246,18.621Z",
    transform: "translate(-695.706 -692.555)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111-2",
    "data-name": "Path 111",
    d: "M746.918,828.072l-.629-1.853-.273-.808a.011.011,0,0,1,0-.01l-4.271-12.626-.613-1.811c16.265-6.313,51.5-17.016,60.5-9.525l0,.005a3.034,3.034,0,0,1,.285.256c.006,0,.014,0,.017.013.094.089.183.181.271.273a2,2,0,0,1,.222.252.729.729,0,0,1,.083.1,5.681,5.681,0,0,1,.545.826,4.426,4.426,0,0,1,.207.441,5.475,5.475,0,0,1,.333,1.036c.08.37.146.733.19,1.09a10.635,10.635,0,0,1,.085,1.867C803.215,823.724,765.444,827.829,746.918,828.072Z",
    transform: "translate(-702.726 -692.483)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112-2",
    "data-name": "Path 112",
    d: "M725.78,819.338s-29.618-5.787-30.909,6.734c-1.386,13.452,33.92,3.38,33.92,3.38s-13.617,2.98-12.97-4.658C716.446,817.4,725.78,819.338,725.78,819.338Z",
    transform: "translate(-694.831 -695.744)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113-2",
    "data-name": "Path 113",
    d: "M775.524,749.32c-5.812,8.163-.614,30.507-.614,30.507H735.889c1.078-1.529,4.117-20.787-2.727-31.4-11.044-17.126.855-30.441.855-30.441l16.229-2.95,1.036-5.167.711-3.559.167-.827h7.3l.264,1.552.572,3.383.845,4.99,14.918,3.238S788.835,730.619,775.524,749.32Z",
    transform: "translate(-700.566 -676.556)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114-2",
    "data-name": "Path 114",
    d: "M793.723,768.879c-.406,2.528-2.187,5.27-4.822,7.98-6.742,6.924-20.473,6.614-29.894,9.132l-.983-5.019s16.816-4.743,20.433-10.642a5.7,5.7,0,0,0,.758-1.739c1.226-5.878-5.58-13.229-5.58-13.229l-.724-34.128s22.86,34.789,20.812,47.645Zm-47.141,12.178.171,3.338a.316.316,0,0,0-.036-.607c-8.4-1.734-22.192.665-28.91-5.04-4.139-3.52-6.4-7.854-6.934-11.194-2.048-12.856,20.249-46.969,20.249-46.969l-.824,34.084s-6.806,7.351-5.58,13.229a9.512,9.512,0,0,0,2.251,3.744C732.006,777.552,746.582,781.057,746.582,781.057Z",
    transform: "translate(-697.544 -679.132)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116-2",
    "data-name": "Path 116",
    d: "M800.212,821.241c2.35,10.031-24.353,5.168-29.307,4.182-.507-.1-.786-.159-.786-.159s-3.87.181-9.771.157H760c-8.569-.045-21.244-.513-32.6-2.539-13.934-2.482-25.891-7.3-25.87-16.526a.192.192,0,0,0,0-.05,10.6,10.6,0,0,1,.071-1.147.044.044,0,0,0,0-.02c.048-.4.115-.806.2-1.22a5.518,5.518,0,0,1,.331-1.057,4.576,4.576,0,0,1,.207-.451c.082-.153.169-.3.263-.448a.005.005,0,0,0,0-.006c.086-.135.183-.266.28-.391a.745.745,0,0,1,.084-.1,2.121,2.121,0,0,1,.224-.259c.09-.095.179-.189.275-.279,0-.011.011-.018.017-.013a9.391,9.391,0,0,1,4.439-2.1c12.738-2.834,41.65,7.079,56.305,12.628.212.08.426.163.633.243,5.04,1.908,8.234,3.251,8.234,3.251s.985-.189,2.585-.407c.019,0,.039,0,.063-.008,6.409-.863,22.393-2.091,24.463,6.715Z",
    transform: "translate(-695.974 -692.387)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117-2",
    "data-name": "Path 117",
    d: "M765.476,809.763l-.61,1.849-4.518,13.731-.625,1.892a174.255,174.255,0,0,1-29.311-2.648l-.006,0c-15.181-2.812-28.928-8.283-28.875-18.306a.193.193,0,0,0,0-.05c0-.376.03-.762.071-1.147a.043.043,0,0,0,0-.02c.048-.4.115-.806.2-1.22a5.52,5.52,0,0,1,.331-1.058,4.592,4.592,0,0,1,.207-.45c.082-.154.169-.3.263-.448a.005.005,0,0,0,0-.006c.086-.134.183-.266.28-.392a.763.763,0,0,1,.084-.1,2.142,2.142,0,0,1,.224-.259c.09-.094.179-.189.275-.28,0-.011.011-.018.017-.013a9.966,9.966,0,0,1,4.658-2.289c13.1-3.2,42.7,5.68,57.328,11.216Z",
    transform: "translate(-695.974 -692.311)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118-2",
    "data-name": "Path 118",
    d: "M787.21,818.106s30.117-6.143,31.537,6.6c1.525,13.689-34.519,3.727-34.519,3.727s13.167,2.493,12.445-5.279C795.974,815.632,787.21,818.106,787.21,818.106Z",
    transform: "translate(-710.075 -695.509)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120-2",
    "data-name": "Path 120",
    d: "M748.7,690.663a12.477,12.477,0,0,1-1.1-14.591s1.433,2.6,3.132,1.879c0,0,.089-6.086,12.442-7.34,0,0-.9,2.416-.448,3.043,4.073-1.79,8.025,2.655,11.994.985,0,0,1.1,7.052-3.469,11.17a6.287,6.287,0,0,1-.918,4.853C768.719,693.08,748.7,690.663,748.7,690.663Z",
    transform: "translate(-703.512 -670.611)",
    fill: "#0e3475"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121-2",
    "data-name": "Path 121",
    d: "M750.922,690.943s-2.668-2.609-2.919-.077c-.3,3,3.27,5.226,3.27,5.226s.87,9.266,8.687,9.266c7.755,0,9.051-9.3,9.051-9.3s4.079-1.112,3.214-4.634c-.411-1.672-2.536.036-2.536.036v-4.4s-2.174,1.1-6.371-.694c-3.038-1.3-4.121-3.115-6.717-3.012-2.96.118-5.795,3.365-5.679,7.592Z",
    transform: "translate(-703.895 -672.783)",
    fill: "#ffd8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5513",
    "data-name": "Path 5513",
    d: "M785.782,738.129l-.013-.037c-4.293-8.808-9.37-16.14-12.906-17.456l-.032-.031-.166-.036a3.161,3.161,0,0,0-.562-.123l-14.187-3.085c-1.416,3.044-10.269,3.258-10.892-.373l-16.237,2.955-.01.012c-4.444,1.466-11.978,13.388-16.771,25.459a.547.547,0,0,0-.022.07c-3.378,8.506-5.381,17.074-3.972,22.087a24.214,24.214,0,0,0,7.479,11.286l2.829-2.352,7.039-5.855c-1.2-1.408-2.63-2.322-2.843-3.368-.917-4.395,4.871-9.426,7.851-11.687h0c3.553,10.722,1.216,24.89.3,26.191h39.024s-4.143-17.8-.894-27.428c3.019,2.847,8.875,9.031,7.957,13.424a5.461,5.461,0,0,1-.688,1.784l7.578,4.911,2.889,1.877a.764.764,0,0,0,.976-.121,17.106,17.106,0,0,0,4.237-7.973C794.99,761.494,790.967,748.759,785.782,738.129Z",
    transform: "translate(-697.536 -678.828)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119-2",
    "data-name": "Path 119",
    d: "M779.444,755.044H730.369c-1.724,0-2.857,1.753-2.536,3.868l4.838,31.9a3,3,0,0,0,2.848,2.51h38.776a3,3,0,0,0,2.847-2.51l4.838-31.9c.322-2.115-.811-3.868-2.535-3.868Z",
    transform: "translate(-700.449 -685.008)",
    fill: "url(#linear-gradient-5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8770",
    "data-name": "Group 8770",
    transform: "translate(105.206 109.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4635",
    "data-name": "Group 4635",
    transform: "translate(48.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M131.71,370.129a7.554,7.554,0,0,0-3.427,5.939c.006,2.182,1.551,3.062,3.45,1.966a7.555,7.555,0,0,0,3.43-5.938C135.156,369.911,133.612,369.031,131.71,370.129Zm-.02-7.166a23.982,23.982,0,0,0-9.048,10.232c-.326.753-.191,1.439.3,1.535a.877.877,0,0,0,.6-.135,2.3,2.3,0,0,0,.89-1.057,19.261,19.261,0,0,1,7.267-8.1c4.866-2.809,6.952-.091,7.037.021.2.28.561.293.932.079a1.961,1.961,0,0,0,.538-.477,1.8,1.8,0,0,0,.387-1.914C140.481,362.99,137.83,359.418,131.69,362.963Zm19.818-22.723c-.242-.338-6.081-8.2-19.737-.317-13.61,7.858-19.882,22.09-20.142,22.693-.328.756-.193,1.443.3,1.538a.885.885,0,0,0,.6-.136,2.307,2.307,0,0,0,.892-1.062c.057-.133,5.94-13.393,18.358-20.564,12.378-7.146,17.657-.14,17.873.162.2.28.563.292.932.079a1.974,1.974,0,0,0,.538-.479A1.8,1.8,0,0,0,151.509,340.24Z",
    transform: "translate(-111.451 -336.426)",
    fill: "#c4d9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M152.633,403.592c-8.9,5.136-13.011,14.478-13.181,14.872-.328.756-.193,1.443.3,1.538a.881.881,0,0,0,.6-.136,2.312,2.312,0,0,0,.892-1.06,30.111,30.111,0,0,1,11.4-12.745c7.663-4.424,10.94-.11,11.074.074.2.28.561.293.932.079a1.96,1.96,0,0,0,.538-.477,1.8,1.8,0,0,0,.387-1.914c-.159-.224-4-5.393-12.937-.232Z",
    transform: "translate(-132.362 -385.192)",
    fill: "#c4d9f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M143.5,175.858c-10.959,6.328-16.019,17.81-16.228,18.3-.328.756-.193,1.443.3,1.538a.885.885,0,0,0,.6-.136,2.308,2.308,0,0,0,.892-1.062c.187-.427,4.674-10.525,14.445-16.166,9.725-5.615,13.877-.123,14.048.113.2.28.561.293.932.079a1.965,1.965,0,0,0,.538-.477,1.8,1.8,0,0,0,.387-1.916c-.2-.272-4.911-6.62-15.911-.269Z",
    transform: "translate(-123.205 -164.782)",
    fill: "#c4d9f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M286.836,558.171l6.581-6.582a3.824,3.824,0,1,0-5.407-5.41l-6.581,6.582-6.581-6.582a3.824,3.824,0,1,0-5.407,5.41l6.58,6.582-6.568,6.567a3.825,3.825,0,0,0,5.41,5.41l6.568-6.569L288,570.148a3.826,3.826,0,0,0,5.411-5.41Z",
    transform: "translate(-111.949 -403.079)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1208.422,466.1a3.991,3.991,0,0,1-2.288,5.916l-13.366,3.9a3.989,3.989,0,0,1-4.99-4.778l3.307-13.523a3.989,3.989,0,0,1,6.633-1.934l10.057,9.626A3.982,3.982,0,0,1,1208.422,466.1Zm-17.493,6.422a.83.83,0,0,0,.96.373l13.369-3.9a.819.819,0,0,0,.581-.611.828.828,0,0,0-.235-.81l-10.057-9.626a.845.845,0,0,0-1.406.411l-3.307,13.522a.812.812,0,0,0,.1.639Z",
    transform: "translate(-1187.658 -320.989)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M69.4,407.333a9.2,9.2,0,1,1,9.2-9.2,9.211,9.211,0,0,1-9.2,9.2Zm0-15.52a6.321,6.321,0,1,0,6.321,6.321A6.328,6.328,0,0,0,69.4,391.813Z",
    transform: "translate(72.58 -348.52)",
    fill: "url(#linear-gradient-13)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtPmobileImg);
export default __webpack_public_path__ + "static/media/OTPmobileImg.5d0c6665c98dff6db679a1aa1fa3c274.svg";
export { ForwardRef as ReactComponent };